import { get as getLocalStorage, set as setLocalStorage } from 'lib/storage/isomorphicLocalStorage'

const LOYALTY_BANNER_DISMISSED_KEY = 'loyalty_membership_activation_banner_dismissed'

export function dismissLoyaltyMembershipActivationBanner(): void {
  setLocalStorage(LOYALTY_BANNER_DISMISSED_KEY, true)
}

export function isLoyaltyMembershipActivationBannerDismissed(): boolean {
  return getLocalStorage(LOYALTY_BANNER_DISMISSED_KEY) === true
}
